<div id="loading" #loading>
  <div id="loadCon" class="load-container">
    <div id="preloader">
      <div></div>
    </div>
  </div>
</div>

<div class="fxed020-wrapper">
  <div class="fx_head_top">
    <div class="fx_container">
      <div class="fx_head_left">
        <!-- <p>{{'fxed020-欢迎光临' | translate}}</p>
        <p class="fx_head_login" (click)="login()" [hidden]="userInfo.userId">{{'fxed020-login' | translate}}</p>
        <dw-dropdown [hidden]="!userInfo.userId" [dwTrigger]="'click'" [dwPlacement]="'bottomRight'">
          <a dw-dropdown>
            {{userInfo.userName}}
          </a>
          <ul dw-menu>
            <li dw-menu-item><i class="anticon anticon-user"></i>{{'fxed020-个人信息' | translate}}</li>
            <li dw-menu-item (click)="onChangePassword()"><i
                class="anticon anticon-unlock"></i>{{'fxed020-修改密码' | translate}}</li>
            <li dw-menu-divider></li>
            <li dw-menu-item><i class="anticon anticon-question-circle-o"></i>{{'fxed020-帮助' | translate}}</li>
            <li dw-menu-item (click)="onLoggedout()"><i class="anticon anticon-logout"></i>{{'fxed020-退出' | translate}}
            </li>
          </ul>
        </dw-dropdown> -->
        <!-- <div class="fx_phone_login" style="position: relative;margin-left: 8px;">
          <p (click)="isClickIphone()"><img src="assets/img/home/phone.svg" />{{'fxed020-手机网站' | translate}}</p>
          <div class="fx_phone_code" style="position: absolute;" *ngIf="isShowIphone">
            <div>
              <img src="{{iphoneImg}}" />
            </div>
            <div>
              <p>{{iphoneIntro}}</p>
              <p>{{iphoneCode}}</p>
            </div>
          </div>
        </div> -->
      </div>
      <div class="fx_head_right">
        <!-- 搜索 -->
        <div class="fx_shop_head_search fx_shop_head_item">
          <dw-input-group dwSearch dwSize="large" [dwSuffix]="suffixButton">
            <input type="text" dw-input (change)="searchData()" [(ngModel)]="searchModel"
              placeholder="{{serchstrInfo}}">
          </dw-input-group>
          <ng-template #suffixButton>
            <i class="anticon anticon-search"></i>
          </ng-template>
        </div>
        <dw-dropdown class="fx_shop_head_item" [dwTrigger]="'click'" [dwPlacement]="'bottomRight'">
          <a dw-dropdown>
            {{userInfo.custName}}
          </a>
          <ul dw-menu style="min-width: 80px;max-height: 60vh;overflow: auto;">
            <li dw-menu-item *ngFor="let item of custList" (click)="switchOrg(item)">{{item.daecust_n1}}</li>
          </ul>
        </dw-dropdown>

        <!-- <p class="fx_head_login" (click)="login()" style="margin-left: 10px;" [hidden]="userInfo.userId">{{'fxed020-login' | translate}}</p> -->
        <dw-dropdown class="fx_shop_head_item" [hidden]="!userInfo.userId" [dwTrigger]="'click'" [dwPlacement]="'bottomRight'">
          <a dw-dropdown style="margin-left: 10px;">
            {{userInfo.userName}}
          </a>
          <ul dw-menu>
            <li dw-menu-item><i class="anticon anticon-user"></i>{{'fxed020-个人信息' | translate}}</li>
            <li dw-menu-item (click)="onChangePassword()"><i class="anticon anticon-unlock"></i>{{'fxed020-修改密码' |
              translate}}</li>
            <li dw-menu-divider></li>
            <li dw-menu-item><i class="anticon anticon-question-circle-o"></i>{{'fxed020-帮助' | translate}}</li>
            <li dw-menu-item (click)="login()"><i class="anticon anticon-login"></i>{{'fxed020-login' | translate}}
            <li dw-menu-item (click)="onLoggedout()"><i class="anticon anticon-logout"></i>{{'fxed020-退出' | translate}}
            </li>
          </ul>
        </dw-dropdown>
        <!-- <div class="fx_head_list"> -->

          <!-- <p>联系我们</p>
          <div *ngFor="let item of wxkefu; let idx = index" style="width: 20px;height: 25px;float: left;margin-left: 10px;">
            <div id="{{idx}}" style="display: none;z-index: 999;padding-top: 40px;position: absolute;">
              <img  class="img-logo" src="{{item.dfa004}}" style="width: 100px;height: 100px;" />
            </div>
            <img style="width: 15px;height: 15px;" class="img-logo" src="./assets/img/layout/weChat.png"  (mouseout)="hiddenPic(idx)" (mouseover)="showPic(idx)"/>
          </div> -->
        <!-- </div> -->
        <a class="fx_shop_head_item" (click)="changeRoute('./orderlist')" *ngIf="isOrderMeenting">货品榜单</a>
        <a class="fx_shop_head_item" (click)="openPayPage()" *ngIf="isbtnPayShow"><i class="anticon anticon-pay-circle-o"></i>{{'打款' |translate}}</a>
        <a class="fx_shop_head_item" (click)="changeRoute('./car')" *ngIf="!isOrderMeenting"><i class="anticon anticon-shopping-cart"></i>{{'fxed020-我的购物车' | translate}}</a>
        <a class="fx_shop_head_item" (click)="changeRoute('./car2')" *ngIf="isOrderMeenting">订货会购物车</a>
        <dw-dropdown class="fx_shop_head_item" [hidden]="!userInfo.mainLang" [dwTrigger]="'click'" [dwPlacement]="'bottomRight'">
          <a dw-dropdown >
            {{userInfo.mainLangName}}
          </a>
          <ul dw-menu style="min-width: 80px;max-height: 60vh;overflow: auto;">
            <li dw-menu-item *ngFor="let item of langList" (click)="switchLang(item)">{{item.label}}</li>
          </ul>
        </dw-dropdown>
        <!-- 登录后台 -->
        <div class="fx_shop_head_item" >
          <a (click)="goSystem()">{{'fxed020-后台登入' | translate}}</a>
        </div>
      </div>
    </div>

  </div>

  <div class="fx_head_search">

    <!-- 分类栏 -->
    <div class="fx_shop_bar">
      <div class="fx_container fx_container_bar" style="display: flex;">
        <div class="fx_shop_head_logo" style="width:calc(50vw - 500px); text-align: right;padding-right: 5px;">
          <img src="{{logoImg}}" style="height: 45px;" onerror="this.src='assets/img/home/pic_loss_tiny.png';">
        </div>
        <div class="fx_bar_content" dw-row dwType="flex" dwJustify="space-between" dwAlign="bottom">
          <div dw-col dwSpan="5">
            <!-- 所有商品分类 -->
            <app-fxed020-menu [listData]="listDatas"></app-fxed020-menu>
          </div>
          <div dw-col dwSpan="19">
            <ul class="fx_shop_bar_list">
              <li (click)="changeRoute('/home')" (mouseover)="setEnterClass('home')" (mouseout)="setEnterClass('')">
                <a>
                  <i class="anticon anticon-caret-up" [hidden]="!(activeTab == 'home' || hoverTab == 'home')"></i>
                  <span>{{'fxed020-首页' | translate}}</span>
                </a>
              </li>

              <!-- 产品中心  -->
              <li [routerLink]="['./info',0]" routerLinkActive="isActive" (mouseover)="setEnterClass('info/0')"
                (mouseout)="setEnterClass('')">
                <a>
                  <i class="anticon anticon-caret-up" [hidden]="!(activeTab == 'info/0' || hoverTab == 'info/0')"></i>
                  <span>{{'fxed020-产品中心' | translate}}</span>
                </a>
              </li>

              <!-- 案例中心 -->
              <li (click)="changeRoute('./querySolutionCenter/caseList/tab')"
                [routerLink]="['./querySolutionCenter/caseList/tab']" [hidden]="!querySolutionCenterShow"
                routerLinkActive="isActive" (mouseover)="setEnterClass('querySolutionCenter')"
                (mouseout)="setEnterClass('')">
                <a>
                  <i class="anticon anticon-caret-up"
                    [hidden]="!(activeTab == 'querySolutionCenter' || hoverTab == 'querySolutionCenter')"></i>
                  <span>{{'fxed020-案例中心' | translate}}</span></a>
              </li>

              <li (click)="changeRoute('./downloadcenter')" [hidden]="!downloadCenterShow"
                (mouseover)="setEnterClass('downloadcenter')" (mouseout)="setEnterClass('')">
                <a>
                  <i class="anticon anticon-caret-up"
                    [hidden]="!(activeTab == 'downloadcenter' || hoverTab == 'downloadcenter')"></i>
                  <span>{{'fxed020-下载中心' | translate}}</span></a>
              </li>

              <li (click)="changeRoute('./studycenter')" [hidden]="!studyCenterShow"
                (mouseover)="setEnterClass('studycenter')" (mouseout)="setEnterClass('')"><a><i
                    class="anticon anticon-caret-up"
                    [hidden]="!(activeTab == 'studycenter' || hoverTab == 'studycenter')"></i>
                  <span>{{'fxed020-学习中心' | translate}}</span></a></li>

              <li [routerLink]="['./helpcenter','tab']" [hidden]="!helpCenterShow" routerLinkActive="isActive"
                (mouseover)="setEnterClass('helpcenter')" (mouseout)="setEnterClass('')"><a><i
                    class="anticon anticon-caret-up"
                    [hidden]="!(activeTab == 'helpcenter' || hoverTab == 'helpcenter')"></i>
                  <span>{{'fxed020-帮助中心' | translate}}</span></a></li>

              <li [routerLink]="['./newList']" routerLinkActive="isActive" [hidden]="!newsCenterShow"
                (mouseover)="setEnterClass('newList')" (mouseout)="setEnterClass('')"><a><i
                    class="anticon anticon-caret-up" [hidden]="!(activeTab == 'newList' || hoverTab == 'newList')"></i>
                  <span>{{'fxed020-新闻中心' | translate}}</span></a>
              </li>

              <li (click)="changeRoute('./personalCenter/personals01')" (mouseover)="setEnterClass('personalCenter')"
                (mouseout)="setEnterClass('')" [hidden]="!personalCenterShow">
                <a>
                  <i class="anticon anticon-caret-up"
                    [hidden]="!(activeTab == 'personalCenter' || hoverTab == 'personalCenter')"></i>
                  <span>{{'fxed020-我的中心' | translate}}</span></a>
              </li>
              <li routerLink="./orderMeeting" routerLinkActive="active" [hidden]="!orderMeetingShow"
                (mouseover)="setEnterClass('orderMeeting')" (mouseout)="setEnterClass('')"
                (click)="isOrderMeenting=true">
                <a>
                  <i class="anticon anticon-caret-up"
                    [hidden]="!(activeTab == 'orderMeeting' || hoverTab == 'orderMeeting')"></i>
                  <span>订货会</span></a>
              </li>
              <li style="width: 2px;border-right: 0;"></li>
            </ul>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div class="fx_shop_body" *ngIf="listDatas" style="background-color: white;">
    <div class="fx_container" [ngStyle]="{'width': activeTab == 'home' ? '100vw' : '1226px'}">
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-footer *ngIf="listDatas"></app-footer>

</div>
